export default __webpack_public_path__ + "media/Objective/Objective-Bold-a2f6fa0d9f9815c0b6d537cfa2f9de8c.woff2";